var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "div",
      { staticClass: "card setting-card" },
      [
        _c("ul", { staticClass: "tabs" }, [
          _c(
            "li",
            {
              staticClass: "tab",
              on: {
                click: function ($event) {
                  return _vm.setActiveTab("SHARED")
                },
              },
            },
            [
              _c(
                "a",
                {
                  class: [
                    "tab-link",
                    { "a-active": _vm.activeTab === "SHARED" },
                  ],
                  attrs: { href: "#" },
                },
                [_vm._v(_vm._s(_vm.$t("general.shared")))]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "tab",
              on: {
                click: function ($event) {
                  return _vm.setActiveTab("UNSHARED")
                },
              },
            },
            [
              _c(
                "a",
                {
                  class: [
                    "tab-link",
                    { "a-active": _vm.activeTab === "UNSHARED" },
                  ],
                  attrs: { href: "#" },
                },
                [_vm._v(_vm._s(_vm.$t("general.unshared")))]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade-customize" } }, [
          _vm.activeTab === "SHARED"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c(
                      "table-component",
                      {
                        ref: "table",
                        attrs: {
                          "show-filter": false,
                          data: _vm.sharingProfileUsers,
                          "table-class": "table",
                        },
                      },
                      [
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("general.company_name"),
                            show: "company_name",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.display_name"),
                            show: "name",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.contact_name"),
                            show: "contact_name",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.phone"),
                            show: "phone",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade-customize" } }, [
          _vm.activeTab === "UNSHARED"
            ? _c("div", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.showEmptyScreen,
                        expression: "!showEmptyScreen",
                      },
                    ],
                    staticClass: "table-container",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "table-actions" },
                      [
                        _c("p", { staticClass: "table-stats" }, [
                          _vm._v(_vm._s(_vm.$t("general.showing")) + ": "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.unSharingProfileUsers.length)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "fade" } },
                          [
                            _vm.selectedUsers.length
                              ? _c(
                                  "v-dropdown",
                                  { attrs: { "show-arrow": false } },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "table-actions-button dropdown-toggle",
                                        attrs: { slot: "activator", href: "#" },
                                        slot: "activator",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.$t("general.actions")) +
                                            "\n                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-dropdown-item", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "dropdown-item",
                                          on: { click: _vm.sharedProfile },
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            staticClass: "dropdown-item-icon",
                                            attrs: { icon: ["fas", "share"] },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("general.shared")) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "custom-control custom-checkbox" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectAllFieldStatus,
                              expression: "selectAllFieldStatus",
                            },
                          ],
                          staticClass: "custom-control-input",
                          attrs: { id: "select-all", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.selectAllFieldStatus)
                              ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                              : _vm.selectAllFieldStatus,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.selectAllFieldStatus,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectAllFieldStatus = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectAllFieldStatus = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectAllFieldStatus = $$c
                                }
                              },
                              _vm.selectAllUsers,
                            ],
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "custom-control-label selectall",
                            attrs: { for: "select-all" },
                          },
                          [
                            _c("span", { staticClass: "select-all-label" }, [
                              _vm._v(
                                _vm._s(_vm.$t("general.select_all")) + " "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "table-component",
                      {
                        ref: "table",
                        attrs: {
                          "show-filter": false,
                          data: _vm.unSharingProfileUsers,
                          "table-class": "table",
                        },
                      },
                      [
                        _c("table-column", {
                          attrs: {
                            sortable: false,
                            filterable: false,
                            "cell-class": "no-click",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (row) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-checkbox",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.selectField,
                                              expression: "selectField",
                                            },
                                          ],
                                          staticClass: "custom-control-input",
                                          attrs: {
                                            id: row.id,
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            value: row.id,
                                            checked: Array.isArray(
                                              _vm.selectField
                                            )
                                              ? _vm._i(
                                                  _vm.selectField,
                                                  row.id
                                                ) > -1
                                              : _vm.selectField,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.selectField,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = row.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.selectField =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.selectField = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.selectField = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("label", {
                                          staticClass: "custom-control-label",
                                          attrs: { for: row.id },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1359643308
                          ),
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.display_name"),
                            show: "name",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.contact_name"),
                            show: "contact_name",
                          },
                        }),
                        _vm._v(" "),
                        _c("table-column", {
                          attrs: {
                            label: _vm.$t("funders.phone"),
                            show: "phone",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }